import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { validateForm } from '@app/functions/validate-form';
import { Employee } from '@app/models/employee/employee.model';
import { Task } from '@app/models/tasks/task.model';
import { OnboardingTaskTemplateTable } from '@app/modules/employees/services';
import { DeprecatedTaskForm } from '@app/modules/forms/company/components';
import { AnalyticService, NotifyService } from '@app/services';

/**
 * This component is used on both the store and edit view
 */
@Component({
    templateUrl: './offboarding-tasks-store.template.html',
    styleUrls: ['./offboarding-tasks-store.style.scss'],
})
export class OffboardingTasksStoreView implements OnInit {
    isLoading = true;
    task = new Task();

    title = '';
    employee: Employee;
    taskId: number;
    events = AnalyticEvents;
    saveEvent: AnalyticEvents;

    constructor(
        public table: OnboardingTaskTemplateTable,
        public analytics: AnalyticService,
        private notify: NotifyService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.employee = this.route.snapshot.data.models.get('employee');
        this.saveEvent = AnalyticEvents.EmployeeProfileOffboardingTaskEdited;
        if (!(this.task = this.route.snapshot.data.models.get('task'))) {
            this.saveEvent = AnalyticEvents.EmployeeProfileOffboardingTaskCreated;
            this.task = new Task();
        }
        this.title = this.getTitle();
    }

    ngOnInit(): void {
        this.task.taskType = 'offboarding';
        this.isLoading = false;
        if (!this.task.id) {
            this.task.dueAt = null;
        }
    }

    getTitle(): string {
        let title = 'Create New Offboarding Task for ';
        if (this.task.id) {
            title = 'Edit Existing Offboarding Task for ';
        }
        return title + this.employee.fullName;
    }

    save(taskForm: DeprecatedTaskForm): void {
        validateForm(taskForm.form);
        if (taskForm.form.invalid) {
            return;
        }

        this.task.subjectId = this.employee.id;
        this.isLoading = true;
        this.task
            .save()
            .then(() => {
                this.notify.success('Offboarding Task Saved');
                this.analytics.trackEvent(this.saveEvent);
                this.router.navigate(['..'], { relativeTo: this.route });
            })
            .catch((err) => {
                this.notify.error(err.message);
                this.isLoading = false;
            });
    }
}
